import React, { useState } from 'react';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';

import { Upload } from 'react-feather';

import { EnchancedModal } from 'src/components/Modals';
import { ModalEvidences } from './ModalEvidences';

import { IEvidences } from './types';

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    paper: {
        overflow: 'scroll',
    },
    margin: {
        marginBottom: '1em',
    },
    button: {
        height: 60,
    },
}));

export const Evidences = ({ lead, loading, ...props }: IEvidences) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const [open, setOpen] = useState<boolean>(false);

    return (
        <Card className={classes.paper} {...props}>
            <CardHeader title={t('Leads.Evidences')} />
            <Divider />
            <CardContent>
                <Button
                    fullWidth
                    startIcon={<Upload />}
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={() => setOpen(true)}
                >
                    {t('Buttons.LoadImages')}
                </Button>
                <EnchancedModal
                    {...{
                        setOpen,
                        open,
                        maxWidth: 'md',
                        title: t('Leads.Evidences'),
                    }}
                >
                    <ModalEvidences
                        leadId={lead._id}
                        loading={loading}
                        medias={lead?.evidences || []}
                    />
                </EnchancedModal>
            </CardContent>
        </Card>
    );
};
